module.exports = __webpack_public_path__ + "media/images/logo1-282494adca1a5b1c439d3580156ff5b0.png";